<template>
    <div class="max-w-3xl mx-auto bg-white border border-gray-300 rounded-lg shadow-lg px-6 py-4 mt-5">

        <div v-if="loading" class="flex justify-center items-center h-32">
                <div class="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-opacity-75"></div>
                <p class="ml-3 text-gray-600">Fetching details...</p>
        </div>

        <div class="py-4" v-else>

            <div class="flex items-center mb-4 pb-2">
                <label class="w-1/3 text-gray-700 font-bold text-right pr-4">Customer Name:</label>
                <div class="font-bold rounded px-3 py-2">{{ customer.name }}</div>
            </div>

            <div class="flex items-center mb-4 pb-2">
                <label class="w-1/3 text-gray-700 font-bold text-right pr-4">City:</label>
                <div class="font-bold rounded px-3 py-2">{{ customer.city }}</div>
            </div>

            <div class="flex items-center mb-4 pb-2">
                <label class="w-1/3 text-gray-700 font-bold text-right pr-4">State:</label>
                <div class="font-bold rounded px-3 py-2">{{ customer.state }}</div>
            </div>

            <div class="flex items-center mb-4 pb-2">
                <label class="w-1/3 text-gray-700 font-bold text-right pr-4">Country:</label>
                <div class="font-bold rounded px-3 py-2">{{ customer.country }}</div>
            </div>

            <div class="flex items-center mb-4 pb-2">
                <label class="w-1/3 text-gray-700 font-bold text-right pr-4">Date of Birth:</label>
                <div class="font-bold rounded px-3 py-2">{{ customer.dob }}</div>
            </div>

            <div class="flex items-center mb-4 pb-2">
                <label class="w-1/3 text-gray-700 font-bold text-right pr-4">Pancard:</label>
                <div class="font-bold rounded px-3 py-2">{{ customer['pan card no'] }}</div>
            </div>

            <div class="flex items-center mb-4 pb-2">
                <label class="w-1/3 text-gray-700 font-bold text-right pr-4">Email:</label>
                <div class="font-bold rounded px-3 py-2">{{ customer.email }}</div>
            </div>

        </div>
    </div>
</template>

<script>

import { apiRequest } from '@/api';

export default {
    name: "AccountDetails",
    data() {
        return {
            customer: {},
            loading : false
        };
    },
    props:{
        user: Object
    },
    created() {
        this.fetchAccountDetails();
    },
    methods: {
        async fetchAccountDetails() {
            this.loading = true;

            try {
                const response = await apiRequest('/account-details','POST',{});

                if (response.data.status === 'success') {
                    this.customer = response.data.customer
                }

            } catch (error) {
                console.error("Error fetching customer details:", error);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.animate-spin {
    animation: spin 1s linear infinite;
}
</style>

